import ServicesSelectEnhanced from './ServicesSelectEnhanced';

const ServicesSelect = (props) => {
  return <ServicesSelectEnhanced {...props} />;
};

export { ServicesSelect };
